/*
 * @Author       : jry
 * @Description  :
 * @version      : 3.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : jry
 * @lastTime     : 2025-05-17 17:17:33
 * @FilePath     : /uview-plus/libs/config/props/parse.js
 */
export default {
    // parse
    parse: {
        copyLink: true,
        errorImg: '',
        lazyLoad: false,
        loadingImg: '',
        pauseVideo: true,
        previewImg: true,
        setTitle: true,
        showImgMenu: true
    }
}
